const RolesHierarchy: Map<string, number> = new Map([
	["User", 1],
	["ResidentViewer", 2],
	["ResidentEditor", 3],
	["CarehomeEditor", 4],
	["Administrator", 5],
	["Admin", 6]
]);

export default RolesHierarchy;